import { createSlice } from '@reduxjs/toolkit';
const userSlice = createSlice({
  name: 'userData',
  initialState: {},
  reducers: {
    setUser: (_, { payload }) => {
      return payload;
    },
    remUser: () => {
      return {};
    }
  }
});
export const { setUser, remUser } = userSlice.actions;
export default userSlice;
